export const Ventilations = {
  wfuk: ["friskluftsventil", "klickventil"],
  wfuks: ["friskluftsventil", "klickventil"],
  wfduk: ["friskluftsventil", "klickventil"],
  wff: ["friskluftsventil", "klickventil"],
  wfik: ["forhojningsdel", "friskluftsventil"],
  wfdik: ["forhojningsdel", "friskluftsventil"]

};
